import { Fragment, h } from "preact";
import { TABS } from "./constants";

export default function SearchTabs({
  productCount,
  pageCount,
  articleCount,
  translations,
  activeTab,
  setActiveTab,
}) {
  return (
    <div className="main-search__tabs">
      <button
        id={`search-tab-${TABS.products}`}
        className={`text--large main-search__tab ${
          activeTab === TABS.products ? "main-search__tab--active" : ""
        }`}
        role="tab"
        aria-selected={activeTab === TABS.products}
        onClick={() => setActiveTab(TABS.products)}
        aria-controls={`search-tabpanel-${TABS.products}`}
      >
        {productCount === 1
          ? translations.product_results_one
          : translations.product_results_other.replace("[count]", productCount)}
      </button>
      <button
        id={`search-tab-${TABS.pages}`}
        className={`text--large main-search__tab ${
          activeTab === TABS.pages ? "main-search__tab--active" : ""
        }`}
        role="tab"
        aria-selected={activeTab === TABS.pages}
        onClick={() => setActiveTab(TABS.pages)}
        aria-controls={`search-tabpanel-${TABS.pages}`}
      >
        {pageCount === 1
          ? translations.page_results_one
          : translations.page_results_other.replace("[count]", pageCount)}
      </button>
      <button
        id={`search-tab-${TABS.articles}`}
        className={`text--large main-search__tab ${
          activeTab === TABS.articles ? "main-search__tab--active" : ""
        }`}
        role="tab"
        aria-selected={activeTab === TABS.articles}
        onClick={() => setActiveTab(TABS.articles)}
        aria-controls={`search-tabpanel-${TABS.articles}`}
      >
        {articleCount === 1
          ? translations.article_results_one
          : translations.article_results_other.replace("[count]", articleCount)}
      </button>
    </div>
  );
}
